import { Box, Button, Fade, Popper } from "@mui/material";
import { useEffect, useState } from "react";
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import { toast } from "react-toastify";
import { useAppSelector } from "../store";
import ExportFileDownloadIcon from '@mui/icons-material/SaveAlt';
import FileDownload from "./FileDownload";

interface ExportQuoteListingProps {
  productAssignmentTotalCount: number;
  setLoading: (loading: boolean) => void;
};

const ExportProductAssignmentListing = (props: ExportQuoteListingProps) => {
  const { productAssignmentTotalCount, setLoading } = props;

  const productAssignmentsListRequest = useAppSelector((state) => state.productAssignments.productAssignmentsListRequest);

  const [popperAnchorEl, setPopperAnchorEl] = useState<null | HTMLElement>(null);

  const handlePopper = (event: React.MouseEvent<HTMLElement>) => {
    setPopperAnchorEl(popperAnchorEl ? null : event.currentTarget);
  };

  //openPopper check if the popper is open or not;
  const openPopper = Boolean(popperAnchorEl);

  //needed for when use click out of popper
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      //if popper is open and click is not popper then set anchor to null which close the popper
      if (popperAnchorEl && !popperAnchorEl.contains(event.target as Node)) {
        setPopperAnchorEl(null);
      }
    };

    if (openPopper) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    } return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openPopper]);

  const handleCSVForPAList = async () => {
    let fileName = 'Product_Assignment_List_';
    let fileFormat = 'Product Assignment List';
    if (productAssignmentTotalCount > 5000) {
      toast.error("Cannot export more than 5000 records. Please narrow down the list using filter options and try again");
    }
    else {
      const fileDownload = await FileDownload({ 
        requestInput: {
          ...productAssignmentsListRequest,
          pageIndex: 0,
          pageSize: 0
        }, 
        inputFileName: fileName, 
        inputFileFormat: fileFormat, 
        setLoading 
      });
      await fileDownload.handleDownload();
    }
  };

  return (
    <>
      <Button
        startIcon={<ExportFileDownloadIcon />}
        onClick={handlePopper}
      >
        EXPORT
      </Button>
      <Popper
        open={openPopper}
        anchorEl={popperAnchorEl}
        placement={"bottom-start"}
        modifiers={[
          {
            name: 'flip',
            enabled: false,
          },
          {
            name: 'preventOverflow',
            options: {
              altBoundary: true,
              tether: false,
            },
          },
        ]}
        transition
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={250}>
            <Box className="product-assignment export-list">
              <Button
                startIcon={<FileDownloadRoundedIcon />}
                onClick={handleCSVForPAList}
              >
                Export Product assignments to CSV
              </Button>
            </Box>
          </Fade>
        )}
      </Popper>
    </>
  )
};

export default ExportProductAssignmentListing;